import React, { useState, useEffect } from "react";
import axios from "axios";

import { API } from "../../backend";
import authHeader from "../../services/auth-header";
import { C, S } from "./styles";
import ManageUser from "../User";

// Same rule the Manage Licenses tab uses: a plan with no per-user price is the free plan.
const isFreeSubscription = (sub) =>
  !!sub && !!sub.plan && (sub.plan.is_free_plan === true || Number(sub.plan.per_user_amount) === 0);

function UsersPage({ onUpgrade }) {
  const [purchased, setPurchased] = useState(null);
  const [used, setUsed] = useState(null);
  const [onFreePlan, setOnFreePlan] = useState(false);

  useEffect(() => {
    axios
      .get(API + "paymentsub/subscription/", { headers: authHeader() })
      .then((res) => {
        if (res.data && res.data.success === 1 && res.data.data) {
          setPurchased(res.data.data.no_of_users ?? 0);
          setOnFreePlan(isFreeSubscription(res.data.data));
        }
      })
      .catch(() => {});

    axios
      .get(API + "company/users/", { headers: authHeader() })
      .then((res) => {
        setUsed(Array.isArray(res.data) ? res.data.length : 0);
      })
      .catch(() => {});
  }, []);

  const hasData = purchased !== null && used !== null;
  const remaining = hasData ? Math.max(purchased - used, 0) : null;
  const atLimit = hasData && purchased > 0 && used >= purchased;

  return (
    <>
      {hasData && (
        <div style={S.licenseCard}>
          <i className="fa-solid fa-id-badge" style={{ color: C.primary, fontSize: 13 }} />

          <div style={S.licenseStat}>
            <span style={S.licenseStatNum}>{purchased}</span>
            <span style={S.licenseStatLabel}>Purchased</span>
          </div>

          <div style={S.licenseDivider} />

          <div style={S.licenseStat}>
            <span style={S.licenseStatNum}>{used}</span>
            <span style={S.licenseStatLabel}>Used</span>
          </div>

          <div style={S.licenseDivider} />

          <div style={S.licenseStat}>
            <span style={{ ...S.licenseStatNum, color: atLimit ? C.warning : C.success }}>
              {remaining}
            </span>
            <span style={S.licenseStatLabel}>Remaining</span>
          </div>
        </div>
      )}

      <ManageUser
        addUserDisabled={onFreePlan}
        addUserDisabledReason="Adding users is available after you upgrade from the free plan."
        onUpgrade={onUpgrade}
      />
    </>
  );
}

export default UsersPage;
